"use client";

import styles from "./Dropdown.module.scss";
import classNames from "classnames";
import * as DropdownBase from "@radix-ui/react-dropdown-menu";
import { ReactNode } from "react";

const DropdownTrigger = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <DropdownBase.Trigger className={className} asChild>
      {children}
    </DropdownBase.Trigger>
  );
};

const DropdownContent = ({
  children,
  width,
  align = "center",
  style = {},
  className,
  role,
  sideOffset = 8,
}: {
  children: ReactNode;
  width?: "fit" | "trigger";
  align?: "start" | "center" | "end";
  style?: any;
  className?: string;
  role?: string;
  sideOffset?: number;
}) => {
  return (
    <DropdownBase.Portal>
      <DropdownBase.Content
        role={role}
        style={style}
        align={align}
        sideOffset={sideOffset}
        className={classNames(
          styles["comp__content"],
          styles[`comp__content--${width}`],
          className
        )}
      >
        {children}
      </DropdownBase.Content>
    </DropdownBase.Portal>
  );
};

const DropdownItem = ({
  children,
  className,
  autoClose = true,
  disabled = false,
  style = {},
  role,
  onClick = () => {},
}: {
  children: ReactNode;
  className?: string;
  autoClose?: boolean;
  disabled?: boolean;
  style?: any;
  role?: string;
  onClick?: (e: any) => void;
}) => {
  return (
    <DropdownBase.Item
      role={role}
      style={style}
      disabled={disabled}
      onSelect={(e) => !autoClose && e.preventDefault()}
      onClick={onClick}
      className={classNames(styles["comp__item"], className)}
    >
      {children}
    </DropdownBase.Item>
  );
};

const Dropdown = ({ children }: { children: ReactNode }) => {
  return <DropdownBase.Root>{children}</DropdownBase.Root>;
};

Dropdown.Trigger = DropdownTrigger;
Dropdown.Content = DropdownContent;
Dropdown.Item = DropdownItem;

export { Dropdown };
